import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {DaytimeService} from 'shared/daytime';
import {AnswerType, Question, TipList, TipRating} from '../model/model';
import {TipRepository} from '../repositories/tip.repository';

const ROOT_TIP_QUESTION_NAME: string = 'tipStart';
const MORNING_QUESTION_NAME: string = 'energylevelMorning';
const EVENING_QUESTION_NAME: string = 'energylevelEvening2';
const RESILIENCE_QUESTION_NAME: string = 'influencer';
const NIGHT_QUESTION_NAME: string = 'detachment';
const PODCAST_QUESTION_NAME: string = 'podcast';

export const PODCAST_TYPE: string = 'podcast';
export const VIDEO_TYPE: string = 'video';
export const TIP_TYPE: string = 'tip';

@Injectable()
export class TipService {

  constructor(
    private daytimeService: DaytimeService,
    private tipRepository: TipRepository,
  ) { }

  public getRootQuestion(): Observable<Question> {
    return this.tipRepository.getQuestionChain(ROOT_TIP_QUESTION_NAME);
  }

  public getQuestion(questId: string): Observable<Question> {
    return this.tipRepository.getQuestion(questId);
  }

  public getMorningInteration(): Observable<Question> {
    return this.tipRepository.getQuestionChain(MORNING_QUESTION_NAME);
  }

  public getEveningInteration(): Observable<Question> {
    return this.tipRepository.getQuestionChain(EVENING_QUESTION_NAME);
  }

  public getResilienceInteration(): Observable<Question> {
    return this.tipRepository.getQuestionChain(RESILIENCE_QUESTION_NAME);
  }

  public getNightInteration(): Observable<Question> {
    return this.tipRepository.getQuestionChain(NIGHT_QUESTION_NAME);
  }

  public getPodcastQuestion(): Observable<Question> {
    return this.tipRepository.getQuestionChain(PODCAST_QUESTION_NAME);
  }

  public postAnswer(questionId: string, value: AnswerType, questionDate: Date, subtree: string): Observable<Question | TipList> {
    return this.tipRepository.postAnswer(questionId, value, questionDate, subtree);
  }

  public skipReflection(questionId: string, questionDate: Date): Observable<boolean> {
    return this.tipRepository.skipReflection(questionId, questionDate);
  }

  public skipOldReflections(): Observable<boolean> {
    return this.tipRepository.skipOldReflections();
  }

  public postTipRating(tipId: string, value: AnswerType): Observable<boolean> {
    return this.tipRepository.postTipRating(tipId, value);
  }

  public getTipRatings(): Observable<Array<TipRating>> {
    return this.tipRepository.getTipRatings();
  }

  public getPodcastButtonAges(name: string): Observable<Array<Date>> {
    return this.tipRepository.getButtonAges(PODCAST_QUESTION_NAME);
  }

  public getByType(type:string): Observable<Array<any>> {
    return this.tipRepository.getByType(type);
  }

}
